export var BASE_URL = "http://horoscope.tapfunstudios.com";
export var BASE_URL_VISION = "http://vision.tapfunstudios.com";
export var API_KEY = "PfjuEIOoInZZXvyVVakrSinMe";
export var SECRET_KEY = "mfzOmzczDZZOyaQthAePrvdwvRRxFjiF";
export var UA = "zodiac/1.1.7 (iPhone; iOS 12.2; Scale/3.00)";
export var IDENTITY_POOL_ID = "us-east-1:707e0974-517d-4be3-a050-a875b2b1e014";
export var REGION_TYPE = "us-east-1";
export var BUNDEL_ID = "com.hundreds.zodiac";
export var APP_BUILD_VERSION = "13";
export var BUCKET = "vision-service-static";
export var FACE_DETECT = "/api/horoscope/v1/face/detect_v2";
export var AGING_SHUTTER = "/api/horoscope/v1/face/face_merge_v2";
export var GENDER_SWITCH = "/api/horoscope/v1/face/trans_gender";
export var LOVE_COMPATIBILITY = "/api/v1/compatibility/love";
export var ZODIAC_COMPATIBILITY = "/api/v1/compatibility";